import { Box, Chip, Grid, IconButton, Tooltip } from "@material-ui/core";
import CardLojista from "../components/card-lojista";
import CardRepresentante from "../components/card-representante";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import FormUserDialog from "components/Dialogs/FormUserDialog";
import LoadingData from "components/Loading/LoadingData";
import ToggleCell from "components/Cells/ToggleCell";
import { Create } from "@mui/icons-material";
import TableFiltrosAvancados from "../components/table-filtros-avancados";

export default function DadosGeraisView({
  hasAccessToUserRegister,
  users,
  setSelectedUser,
  setFormType,
  toggleField,
  formType,
  selectedUser,
  storeRegistrationData,
  showCardStore,
  cancelLoading,
  isMobile800,
  registeredUserId,
  setFormTypeCreate,
  showCardRepresentante,
  storeRepresentatives,
  pesquisandoLojista,
  handleStopSearching,
  pesquisandoCNPJ,
  classes,
  isSearchingRegisteredUser,
  setIsSearchingRegisteredUser,
  setUsers,
  setRegisteredUserId,
  listStores,
  consultarCNPJ360,
}) {
  return (
    <>
      {pesquisandoLojista && (
        <Grid item xs={12}>
          <LoadingData
            searching={pesquisandoLojista}
            onClick={() => handleStopSearching()}
            label="Buscando dados cadastrais..."
          />
        </Grid>
      )}
      {!cancelLoading && (
        <Grid item xs={12}>
          <TableFiltrosAvancados
            data={listStores}
            consultarCNPJ360={consultarCNPJ360}
          />
        </Grid>
      )}
      {pesquisandoLojista && (
        <Grid item xs={12}>
          <LoadingData
            searching={pesquisandoCNPJ}
            onClick={() => handleStopSearching()}
            classes={classes.root}
            label="Buscando dados cadastrais..."
          />
        </Grid>
      )}
      {isSearchingRegisteredUser && (
        <Grid item xs={12}>
          <LoadingData
            searching={isSearchingRegisteredUser}
            onClick={() => setIsSearchingRegisteredUser(false)}
            classes={classes.root}
            label="Buscando usuário registrado"
          />
        </Grid>
      )}

      {hasAccessToUserRegister && !!users?.length && (
        <Grid item xs={12} hidden={!pesquisandoLojista}>
          <ToolkitTable
            keyField="IdUsuario"
            dataTable={users}
            columnModel={getTableColumns(
              setSelectedUser,
              () => setFormType("edit"),
              toggleField
            )}
            allowEmpty
          />
        </Grid>
      )}

      {hasAccessToUserRegister && (
        <FormUserDialog
          key={String(formType)}
          open={!!formType}
          formType={formType}
          onClose={(user) => {
            setFormType(null);
            setSelectedUser(null);
            if (user?.IdUsuario > 0) {
              setUsers([user]);
              setRegisteredUserId(user?.IdUsuario);
            }
          }}
          selectedUser={
            selectedUser || {
              Nome: storeRegistrationData?.Nome,
              Login:
                storeRegistrationData?.EmailPrincipal ||
                storeRegistrationData?.EmailAlternativo,
            }
          }
        />
      )}
      {showCardStore && !cancelLoading && storeRegistrationData && (
        <CardLojista
          dataCard={storeRegistrationData}
          isMobile={isMobile800}
          isRegistered={!!registeredUserId}
          onRegisterClick={setFormTypeCreate}
        />
      )}
      {showCardRepresentante && !cancelLoading && (
        <CardRepresentante
          representatives={storeRepresentatives}
          isMobile={isMobile800}
        />
      )}
    </>
  );
}

const getTableColumns = (setSelectedUser, setFormType, toggleField) => [
  {
    dataField: "IdUsuario",
    text: "IdUsuario",
  },
  {
    dataField: "Nome",
    text: "Nome",
  },
  {
    dataField: "Login",
    text: "Login",
  },
  {
    dataField: "Perfis",
    text: "Perfis",
    hidden: true,
  },
  {
    dataField: "UsuarioPerfis",
    text: "Perfis",
    sort: false,
    formatter: (profiles) => {
      const profilesList = [];
      profiles?.map((profile) => {
        profilesList.push(profile?.Nome);
      });
      return (
        <>
          {profilesList?.map((profile) => (
            <Chip
              key={profile}
              style={{
                color: profile === "ADM" ? "white" : "#3f3f3f",
                border: "1px solid #3f3f3f",
                backgroundColor: profile === "ADM" ? "#3f3f3f" : "white",
                margin: "1px 1px",
                padding: "0.25rem 0.5rem",
                fontSize: "11px",
              }}
              variant="outlined"
              label={profile}
              size="small"
            />
          ))}
        </>
      );
    },
  },
  {
    dataField: "Inativo",
    text: "Inativo",
    headerStyle: { width: 90 },
    formatter: (_, row) => {
      return (
        <ToggleCell
          initialValue={row.Inativo}
          handleChange={async (params) => {
            row.Inativo = params.Inativo;

            await toggleField({ ...row, ...params }, "Inativo");
          }}
          field="Inativo"
        />
      );
    },
    sort: true,
  },
  {
    dataField: "Backoffice",
    text: "Backoffice",
    headerStyle: { width: 90 },
    formatter: (_, row) => {
      return (
        <ToggleCell
          initialValue={row.Backoffice}
          handleChange={async (params) => {
            row.Backoffice = params.Backoffice;

            await toggleField({ ...row, ...params }, "Backoffice");
          }}
          field="Backoffice"
        />
      );
    },
    sort: true,
  },
  {
    dataField: "editar",
    text: "",
    isDummyField: true,
    formatter: (_, row) => {
      return (
        <Tooltip title="Editar Usuário">
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedUser(row);
              setFormType("edit");
            }}
          >
            <Box
              component={Create}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
    headerStyle: { width: 45 },
  },
];
